import React from "react";

interface ScrollableModalBodyProps {
  children: React.ReactNode;
  maxHeight?: string; // Tailwind height class like "max-h-[70vh]"
  className?: string;
}

export default function ScrollableModalBody({
  children,
  maxHeight = "tw-max-h-[70vh]",
  className = "",
}: ScrollableModalBodyProps) {
  return (
    <div className={`tw-pr-2 ${maxHeight} ${className}`}>
      {children}
    </div>
  );
}
